import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X, Loader2 } from 'lucide-react';
import { API } from '../../../utils/api';

const inputClass =
  'w-full bg-zinc-950 border border-white/10 rounded-xl px-3 py-2.5 text-sm text-white focus:outline-none focus:border-neon-lime/60 transition-colors duration-200';

export const AiApplyDialog = ({ open, onClose, onConfirm, busy }) => {
  const [students, setStudents] = useState([]);
  const [userId, setUserId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    if (!open || students.length) return;
    axios.get(`${API}/admin/users`).then((res) => {
      setStudents(res.data.filter((u) => u.role !== 'admin'));
    }).catch((e) => console.warn('[AiApplyDialog] failed to load students', e));
  }, [open, students.length]);

  if (!open) return null;
  const datesInvalid = Boolean(startDate && endDate && endDate < startDate);
  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-testid="ai-apply-dialog">
      <div className="w-full max-w-md bg-zinc-900 border border-white/10 rounded-2xl p-5 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-primary font-black text-lg text-white">Aplicar a um aluno</h3>
          <button onClick={onClose} className="text-zinc-500 hover:text-white" data-testid="ai-apply-close"><X className="w-5 h-5" /></button>
        </div>
        <select value={userId} onChange={(e) => setUserId(e.target.value)} className={inputClass} data-testid="ai-apply-student">
          <option value="">Selecione o aluno</option>
          {students.map((s) => <option key={s.id} value={s.id}>{s.name} — {s.email}</option>)}
        </select>
        <div className="grid grid-cols-2 gap-3">
          <label className="space-y-1 block">
            <span className="text-xs text-zinc-500">Início (opcional)</span>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className={inputClass} data-testid="ai-apply-start" />
          </label>
          <label className="space-y-1 block">
            <span className="text-xs text-zinc-500">Fim (opcional)</span>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className={inputClass} data-testid="ai-apply-end" />
          </label>
        </div>
        <p className="text-xs text-zinc-500">Os dias são adicionados ao plano atual do aluno, sem apagar os treinos existentes.</p>
        {datesInvalid && <p className="text-xs text-red-400" data-testid="ai-apply-date-error">A data de fim deve ser igual ou depois do início.</p>}
        <button
          onClick={() => onConfirm({ userId, start_date: startDate || null, end_date: endDate || null })}
          disabled={!userId || busy || datesInvalid}
          className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-full bg-neon-lime text-black font-bold text-sm disabled:opacity-50 transition-opacity duration-200"
          data-testid="ai-apply-confirm"
        >
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Aplicar treino
        </button>
      </div>
    </div>
  );
};
